import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CadastroService } from 'src/app/cadastro/cadastro.service';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { MensagensService } from 'src/app/shared/mensagens/mensagens.service';
import { Bandeira } from 'src/app/shared/models/bandeira.enum';
import { ClientePreLogin } from 'src/app/shared/models/cliente-pre-login-model';
import { LogAcaoCliente } from 'src/app/shared/models/log-acao-cliente-enum';
import { LoginStepEnum } from 'src/app/shared/models/login-step-enum';
import { TipoAutenticacao } from 'src/app/shared/models/tipo-autenticacao.enum';
import { Usuario } from 'src/app/shared/models/usuario.model';

@Component({
  selector: 'app-login-por-etapa',
  templateUrl: './login-por-etapa.component.html',
  styleUrls: ['./login-por-etapa.component.scss']
})
export class LoginPorEtapaComponent implements OnInit {

  isCasasBahia = this.autenticacaoService.bandeira === Bandeira.CASAS_BAHIA;

  cliente = new ClientePreLogin();

  LoginStepEnum = LoginStepEnum;

  loginStep: LoginStepEnum = LoginStepEnum.PRE_LOGIN;

  loading = false;

  nomeCliente: string;

  id: string;

  @Input()
  loginLoading = false;

  @Output()
  entrar: EventEmitter<Usuario> = new EventEmitter<Usuario>();

  @Input()
  networkError: string | null = null

  private redirectMap = {
    [LogAcaoCliente.CARTAO_CASAS_BAHIA]: 'https://bit.ly/3DN7Buu',
    [LogAcaoCliente.CARTAO_PONTO]: 'https://bit.ly/3jfwJQN',
    [LogAcaoCliente.COMPRA_CARNE]: 'https://www.casasbahia.com.br/hotsite/carne-digital.aspx?icid=hotbarcdc2024',
  }

  constructor(
    private autenticacaoService: AutenticacaoService,
    private mensagems: MensagensService,
    private router: Router,
    private cadastroService: CadastroService,
  ) { }

  ngOnInit(): void {
    this.redirectMap[LogAcaoCliente.CENTRAL_ATENDIMENTO] = this.isCasasBahia ? 'https://bit.ly/3vgTzxp' : 'https://bit.ly/36R9Y3n';
  }

  async salvarDadosPreLogin(cliente: ClientePreLogin) {
    try {
      this.loading = true;
      cliente.bandeira = this.autenticacaoService.bandeira;
      cliente.origem = TipoAutenticacao.CLIENTE;
      const res = await this.autenticacaoService.salvarDadosPreLogin(cliente);
      this.id = res.id;

      if (!this.isCasasBahia && !res?.possuiCarne) {
        return this.loginStep = LoginStepEnum.RECUSADO;
      }

      if (this.isCasasBahia && !res?.possuiCadastro) {
        return this.loginStep = LoginStepEnum.CADASTRO;
      }

      this.loginStep = LoginStepEnum.SENHA;
    } catch (response) {
      if (response && response.error && response.error.message) {
        this.mensagems.erro(response.error.message);
      } else {
        this.mensagems.erro('Erro ao buscar cliente');
      }
    } finally {
      this.loading = false;
    }
  }

  handleEntrar(senha: string) {
    const usuario = { cpf: this.cliente.cpf, senha };
    this.entrar.emit(usuario as Usuario);
  }

  handleVoltarAoInicio() {
    this.cliente = new ClientePreLogin();
    this.loginStep = LoginStepEnum.PRE_LOGIN;
  }

  async handleEnviarAcaoCliente(acaoCliente: LogAcaoCliente) {
    await this.autenticacaoService.salvarLogAcaoCliente(acaoCliente);
    window.open(this.redirectMap[acaoCliente], '_blank', 'noopener, noreferrer');
  }

  handleForgotPassword() {
    this.cadastroService.saveUserDocumentToSessionStorage(this.cliente.cpf);
    this.router.navigate(['/recuperar-senha']);
  }

}